import React from 'react'
import { Portal } from 'react-portal'

import { Loader } from 'components/_new/ui'

import s from './OverlayLoader.scss'


export type OverlayLoaderProps = {
  name?: string
  isVisible?: boolean
}

const OverlayLoader: React.FunctionComponent<OverlayLoaderProps> = ({ name, isVisible = true }) => isVisible && (
  <Portal>
    <Loader className={s.overlayLoader} name={name} />
  </Portal>
)


export default OverlayLoader
